export const REQUEST_MENU_FOOTER_TEST_ID = 'request-menu-footer';
export const REQUEST_MENU_HIDDEN_CLASS = 'hide';
